/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type AnnotationQueueObjectType = "TRACE" | "OBSERVATION" | "SESSION";
export const AnnotationQueueObjectType = {
  Trace: "TRACE",
  Observation: "OBSERVATION",
  Session: "SESSION",
} as const;
